import { forwardRef } from 'react'
import { format } from 'date-fns'
import ReactDatePicker from 'react-datepicker'
import IconChevronDown from '@/components/icons/IconChevronDown'
import IconForward from '@/components/icons/IconForward'
import IconFastForward from '@/components/icons/IconFastForward'

import 'react-datepicker/dist/react-datepicker.css'
import './DatePicker.css'

const DatePickerInput = forwardRef(({ className, value, onClick }, ref) => (
  <div
    ref={ref}
    className={`${className} date-picker-input noselect`}
    onClick={onClick}
  >
    {value ? value : <span className="date-range-placeholder">From - To</span>}
    <IconChevronDown className="icon-chevron-down" />
  </div>
))

export default function DatePicker({ dateRange, setDateRange }) {
  const [startDate, endDate] = dateRange
  return (
    <ReactDatePicker
      calendarClassName="date-picker-calendar"
      dateFormat="yyyy-MM-dd"
      formatWeekDay={day => day.slice(0, 3)}
      startDate={startDate}
      endDate={endDate}
      onChange={setDateRange}
      selectsRange={true}
      showPopperArrow={false}
      customInput={<DatePickerInput />}
      renderCustomHeader={({
        date,
        decreaseYear,
        increaseYear,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled
      }) => (
        <div className="date-picker-header noselect">
          <div className="control-icon" onClick={decreaseYear}>
            <IconFastForward className="icon-fast-backward" />
          </div>
          <div className="control-icon" onClick={decreaseMonth}>
            <IconForward className="icon-backward" />
          </div>
          <div className="empty-fill-box" />
          {format(date, 'yyyy MMM')}
          <div className="empty-fill-box" />
          <div className="control-icon" onClick={increaseMonth}>
            <IconForward />
          </div>
          <div className="control-icon" onClick={increaseYear}>
            <IconFastForward />
          </div>
        </div>
      )}
    />
  )
}
